import {doc,getDoc,runTransaction} from 'firebase/firestore';

const historyRef=(db,uid)=>{
  if(!uid)throw new Error('Sign in to manage your analysis history.');
  return doc(db,'users',uid,'meta','insights');
};
const cleanHistory=history=>Array.isArray(history)?history.filter(entry=>entry&&entry.id!=null&&typeof entry==='object').slice(0,20):[];
const savedEntry=entry=>{const {pendingSync,...saved}=entry;return saved;};
export function mergePendingInsights(remote,local){
  const saved=cleanHistory(remote),ids=new Set(saved.map(entry=>String(entry.id)));
  return [...cleanHistory(local).filter(entry=>entry.pendingSync&&!ids.has(String(entry.id))),...saved].slice(0,20);
}
export async function loadSavedInsights(db,uid){
  const snapshot=await getDoc(historyRef(db,uid));
  return snapshot.exists()?cleanHistory(snapshot.data().history):[];
}
export async function appendSavedInsights(db,uid,entries){
  const incoming=cleanHistory(entries);
  if(!incoming.length)throw new Error('There is no saved analysis to sync.');
  const ref=historyRef(db,uid);
  return runTransaction(db,async tx=>{
    const snapshot=await tx.get(ref),current=snapshot.exists()?cleanHistory(snapshot.data().history):[];
    const removed=new Set(snapshot.exists()&&Array.isArray(snapshot.data().deletedIds)?snapshot.data().deletedIds.map(String):[]);
    const ids=new Set(current.map(entry=>String(entry.id))),added=[];
    for(const entry of incoming){const id=String(entry.id);if(!ids.has(id)&&!removed.has(id)){ids.add(id);added.push(savedEntry(entry));}}
    if(!added.length)return current;
    const history=[...added,...current].slice(0,20);
    tx.set(ref,{history,updatedAt:Date.now()},{merge:true});
    return history;
  });
}
export async function removeSavedInsight(db,uid,id){
  if(id==null)throw new Error('Choose a saved analysis to remove.');
  const ref=historyRef(db,uid);
  return runTransaction(db,async tx=>{
    const snapshot=await tx.get(ref),current=snapshot.exists()?cleanHistory(snapshot.data().history):[];
    const history=current.filter(entry=>String(entry.id)!==String(id));
    const deletedIds=snapshot.exists()&&Array.isArray(snapshot.data().deletedIds)?snapshot.data().deletedIds.map(String):[];
    if(history.length!==current.length||!deletedIds.includes(String(id)))tx.set(ref,{history,deletedIds:[String(id),...deletedIds.filter(value=>value!==String(id))].slice(0,100),updatedAt:Date.now()},{merge:true});
    return history;
  });
}
